import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import Wangeditor from '../../components/Wangeditor/index';
import { Form, Input, Button, message, Checkbox, Radio } from 'antd';
import PreviewUploadComponent from '../../components/Upload/previewImg';
import services from '../../services/api';

const { TextArea } = Input;
class SinglePagesAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {},
      isLoadedContent: false
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname.indexOf('edit') !== -1) {
      if (nextProps.match.params.id !== this.id) {
        this.id = nextProps.match.params.id;
        this.getDetail();
      }
    }
  }

  /**获取详情 */
  getDetail = () => {
    services.singlePages.queryOne({ id: this.id }).then(data => {
      if (data.code === 0) {
        this.props.form.setFieldsValue({
          title: data.data.title,
          des: data.data.des,
          cname: data.data.cname,
          content: { html: data.data.content }
        });
        this.setState({
          isLoadedContent: false
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      const params = {
        ...values,
        content: values.content.html
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services.singlePages[this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            if (this.actionType === 'add') {
              this.props.history.push(this.getListUrl());
            }
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };
  loadedContent = isLoadedContent => {
    this.setState({
      isLoadedContent: isLoadedContent
    });
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '名称',
          className: 'tantuer-form-item'
        },
        name: 'title',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入名称' }]
        },
        component: <Input placeholder="名称" className="large" />
      },

      {
        label: {
          label: '别名',
          className: 'tantuer-form-item'
        },
        name: 'cname',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="别名" className="default" />
      },

      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      }
    ];

    const formItems2 = [
      {
        label: {
          label: '详情',
          className: 'tantuer-form-item'
        },
        name: 'content',
        options: {
          initialValue: { html: '' },
          rules: [{ required: true, message: '请输入详情' }]
        },
        component: (
          <Wangeditor
            isLoadedContent={this.state.isLoadedContent}
            loadedContent={this.loadedContent}
          />
        )
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItems2.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(SinglePagesAdd);
